import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { bannerAPI, newsAPI, videoAPI, adsAPI, imagaeAPI, YouTubevideoAPI, BengaluruNewsAPI, KarnatakaNewsAPI, NationalNewsAPI, YouTubevideoMetroAPI } from '../../services/api';
import Header from './Header';
import Footer from './Footer';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// React Toastify CSS
import 'react-toastify/dist/ReactToastify.css';

// ---------- Main Homepage Component ----------
const Homepage = () => {
    // State
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [videos, setVideos] = useState([]);
    const [ads, setAds] = useState([]);
    const [temperature, setTemperature] = useState('Loading...');
    const [youtubevideos, setYouTubeVideos] = useState([]);
    const [youtubevideosmetro, setYouTubeVideosMetro] = useState([]);
    const [error, setError] = useState(null);

    const [bengaluruallNews, setBengaluruAllNews] = useState([]);
    const [karnatakaallNews, setKarnatakaAllNews] = useState([]);
    const [nationalallNews, setNationalAllNews] = useState([]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

    };



    const fetchBanners = async () => {
        setLoading(true);
        try {
            const res = await bannerAPI.getAll();
            setBanners(res.data.data);
        } catch (error) {
            console.error("Error fetching banners:", error);
        }
        finally {
            setLoading(false);
        }
    };

    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await adsAPI.getAll();
            setAds(res.data.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
        finally {
            setLoading(false);
        }
    };

    const fetchBengaluruNews = async () => {
        setLoading(true);
        try {
            const res = await BengaluruNewsAPI.getAll();
            // Fix: res.data is the array directly
            setBengaluruAllNews(res.data);
        } catch (error) {
            console.error("Error fetching Bengaluru news:", error);
        } finally {
            setLoading(false);
        }
    };

    const leftCol = bengaluruallNews.slice(0, 3);
    const rightCol = bengaluruallNews.slice(3, 6);


    const fetchKarnatakaNews = async () => {
        setLoading(true);
        try {
            const res = await KarnatakaNewsAPI.getAll();
            // Fix: res.data is the array directly
            setKarnatakaAllNews(res.data);
        } catch (error) {
            console.error("Error fetching Karnataka news:", error);
        } finally {
            setLoading(false);
        }
    };

    const leftColkarn = karnatakaallNews.slice(0, 3);
    const rightColkarn = karnatakaallNews.slice(3, 6);


    const fetchNationalNews = async () => {
        setLoading(true);
        try {
            const res = await NationalNewsAPI.getAll();
            // Fix: res.data is the array directly
            setNationalAllNews(res.data);
        } catch (error) {
            console.error("Error fetching National news:", error);
        } finally {
            setLoading(false);
        }
    };

    const leftColnat = nationalallNews.slice(0, 3);
    const rightColnat = nationalallNews.slice(3, 6);


    const fetchYouTubeVideos = async () => {
        setLoading(true);
        try {
            const response = await YouTubevideoAPI.getAll();
            // Axios → response.data
            if (response.data.success) {
                setYouTubeVideos(response.data.data);
            } else {
                setError('Failed to load videos');
            }
        } catch (err) {
            console.error(err);
            setError('Error fetching videos');
        } finally {
            setLoading(false);
        }
    };

    const fetchYouTubeVideosMetro = async () => {
        setLoading(true);
        try {
            const response = await YouTubevideoMetroAPI.getAll();
            // Axios → response.data
            if (response.data.success) {
                setYouTubeVideosMetro(response.data.data);
            } else {
                setError('Failed to load videos');
            }
        } catch (err) {
            console.error(err);
            setError('Error fetching videos');
        } finally {
            setLoading(false);
        }
    };




    const fetchNews = async () => {
        setLoading(true);
        try {
            const res = await newsAPI.getAll();
            setAllNews(res.data.data);
        } catch (error) {
            console.error("Error fetching news:", error);
        }
        finally {
            setLoading(false);
        }
    };

    const getBreakingNews = allNews.filter(n => n.breaking_news === true && n.status === 'active');



    const getAds = () =>
        ads.filter(n => n.status === 'active');



    useEffect(() => {
        fetchBanners();
        fetchNews();
        fetchYouTubeVideos();
        fetchBengaluruNews();
        fetchKarnatakaNews();
        fetchNationalNews();
        fetchAds();
        fetchYouTubeVideosMetro();

        fetch('https://wttr.in/Bengaluru?format=j1')
            .then(res => res.json())
            .then(data => {
                setTemperature(data.current_condition[0].temp_C + '°C');
            })
            .catch(() => setTemperature('N/A'));

    }, []);


    if (loading) {
        return (
            <div className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    // ---------- Render ----------
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Header temperature={temperature} />


            {/* ===== MAIN CONTENT ===== */}
            <main>

                {/* ---------- BANNER SLIDER ---------- */}
                <section className="banner-section-5__area">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        navigation={{
                            nextEl: '.banner-section-5__arrow-next',
                            prevEl: '.banner-section-5__arrow-prev',
                        }}
                        autoplay={{ delay: 5000 }}
                        loop={true}
                        className="banner-section-5__active"
                    >
                        {banners.length > 0 ? (
                            banners.map((banner) => (
                                <SwiperSlide key={banner.id}>
                                    <div
                                        className="banner-section-5__wrapper"
                                        style={{ backgroundImage: `url(${imagaeAPI}/uploads/banners/${banner.product_photo})` }}
                                    >

                                    </div>
                                </SwiperSlide>
                            ))
                        ) : (
                            <SwiperSlide>
                                <div className="banner-section-5__wrapper" style={{ backgroundImage: 'url("assets/img/home-slider/blank_banner1.png")' }}>

                                </div>
                            </SwiperSlide>
                        )}
                        {/* Arrows */}
                        <div className="banner-section-5__button">
                            <div className="banner-section-5__arrow banner-section-5__arrow-next"><i className="fa-solid fa-arrow-up" /></div>
                            <div className="banner-section-5__arrow banner-section-5__arrow-prev"><i className="fa-solid fa-arrow-down" /></div>
                        </div>
                    </Swiper>
                </section>

                {/* ---------- BREAKING NEWS ---------- */}



                <section
                    className="trending-posts-4__area trending-posts-4__space section-space-bottom"

                >

                    <div className="container custom-container">
                        <marquee
                            behavior="scroll"
                            direction="left"
                            loop="infinite"
                            scrollamount={5}
                            onMouseOver={(e) => e.currentTarget.stop()}
                            onMouseOut={(e) => e.currentTarget.start()}
                            style={{ background: '#3d2d5e', color: '#ffffff', padding: '10px', fontSize: '18px', fontWeight: 'bold' }}
                        >
                            {/* Duplicate the link 3 times to fill the gap longer */}
                            <a href="#" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'none', marginRight: '50px' }}>
                                Breaking News
                            </a>
                            <a href="#" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'none', marginRight: '50px' }}>
                                Breaking News
                            </a>
                            <a href="#" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'none', marginRight: '50px' }}>
                                Breaking News
                            </a>
                            <a href="#" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'none', marginRight: '50px' }}>
                                Breaking News
                            </a>
                        </marquee>
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">

                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>
                            <div className="trending-posts-4__btn wow fadeInUp" data-wow-duration="0.7s" data-wow-delay="0.2s">

                                <Link to="/metrotv-allnews-details" className="rr-btn rr-btn-6">
                                    <span className="btn-wrap">
                                        <span className="text-one">View All</span>
                                        <span className="text-two">View All</span>
                                    </span>
                                </Link>
                            </div>

                        </div>
                        {/* Row with equal-height columns using d-flex align-items-stretch */}
                        <div className="row mb-minus-24 d-flex align-items-stretch">
                            {/* Left Column – Text Content */}


                            <div className="col-xl-6 d-flex">
                                <div className="trending-posts-4__wrapper mb-24">
                                    {getBreakingNews.slice(0, 2).map((item) => (
                                        <div
                                            key={item.id}   // use a stable unique id
                                            className="latest-updates-2__item wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="featured-stories__thumb">
                                                <Link to="/news-details-kptv" state={{ id: item.id }}>
                                                    <img
                                                        src={item.photo ? `${imagaeAPI}/uploads/news/${item.photo}` : 'assets/img/blog/noimage.jpg'}
                                                        alt={item.news_title}
                                                    />
                                                </Link>
                                            </div>
                                            <div className="featured-stories__content">
                                                <h3 className="featured-stories__title">
                                                    <Link to="/news-details-kptv" state={{ id: item.id }}>
                                                        {item.news_title}
                                                    </Link>
                                                </h3>
                                                <div className="featured-stories__date">
                                                    <span>{new Date(item.created_at).toLocaleDateString('en-IN')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Right Column – Video / Iframe Content */}
                            <div className="col-xl-6 d-flex">
                                <div className="trending-posts-4__wrapper mb-24 w-100 d-flex">
                                    <div className="latest-updates-2__item w-100 d-flex flex-column">
                                        <div className="featured-stories__content d-flex flex-column flex-grow-1">


                                            {youtubevideosmetro.slice(0, 1).map((video) => (

                                                <div className="featured-video" key={video.id}>

                                                    <div className="video-wrapper" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                                                        <iframe
                                                            src={`https://www.youtube.com/embed/${video.video_id}`}
                                                            title={video.title}
                                                            frameBorder="0"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                            allowFullScreen
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100%',
                                                                height: '100%',
                                                                borderRadius: '8px'
                                                            }}
                                                        />
                                                    </div>
                                                    <h3 className="featured-stories__title mt-2">{video.title}</h3>
                                                    <p className="text-muted">
                                                        {new Date(video.published).toLocaleDateString('en-IN', {
                                                            day: 'numeric',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        })}
                                                    </p>
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* end row */}
                    </div>
                </section>



                {/* ---------- BENGALURU NEWS ---------- */}
                <section className="trending-posts-4__area trending-posts-4__space grey-bg section-space-bottom">
                    <div className="container custom-container">
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s">
                                    Bengaluru News
                                </h3>
                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>
                            <div className="trending-posts-4__btn wow fadeInUp" data-wow-duration="0.7s" data-wow-delay="0.2s">
                                <Link to="/bengaluru-allnews-details" className="rr-btn rr-btn-6">
                                    <span className="btn-wrap">
                                        <span className="text-one">View All</span>
                                        <span className="text-two">View All</span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                        <div className="row mb-minus-24">
                            <div className="col-xl-6">
                                <div className="trending-posts-4__wrapper mb-24">
                                    {leftCol.map((item, index) => (
                                        <div
                                            key={index}
                                            className="latest-updates-2__item wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="featured-stories__thumb">
                                                <Link to="/news-details" state={{ news: item }}>
                                                    <img
                                                        src={item.image || 'assets/img/blog/noimage.jpg'} // fallback image
                                                        alt={item.title}
                                                    />
                                                </Link>
                                            </div>
                                            <div className="featured-stories__content">
                                                <h3 className="featured-stories__title">
                                                    <Link to="/news-details" state={{ news: item }}>
                                                        {item.title}
                                                    </Link>
                                                </h3>
                                                <div className="featured-stories__date">
                                                    <span>{new Date(item.pubDate).toLocaleDateString('en-IN')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="trending-posts-4__wrapper mb-24">
                                    {rightCol.map((item, index) => (
                                        <div
                                            key={index}
                                            className="latest-updates-2__item wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="featured-stories__thumb">
                                                <Link to="/news-details" state={{ news: item }}>
                                                    <img
                                                        src={item.image || 'assets/img/blog/noimage.jpg'} // fallback image
                                                        alt={item.title}
                                                    />
                                                </Link>
                                            </div>
                                            <div className="featured-stories__content">
                                                <h3 className="featured-stories__title">
                                                    <Link to="/news-details" state={{ news: item }}>
                                                        {item.title}
                                                    </Link>
                                                </h3>
                                                <div className="featured-stories__date">
                                                    <span>{new Date(item.pubDate).toLocaleDateString('en-IN')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                {/* ---------- KARNATAKA DISTRICTS NEWS ---------- */}
                <section className="trending-posts-4__area trending-posts-4__space grey-bg section-space-bottom">
                    <div className="container custom-container">
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s">
                                    Karnataka News
                                </h3>
                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>
                            <div className="trending-posts-4__btn wow fadeInUp" data-wow-duration="0.7s" data-wow-delay="0.2s">
                                <Link to="/karnataka-allnews-details" className="rr-btn rr-btn-6">
                                    <span className="btn-wrap">
                                        <span className="text-one">View All</span>
                                        <span className="text-two">View All</span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                        <div className="row mb-minus-24">
                            <div className="col-xl-6">
                                <div className="trending-posts-4__wrapper mb-24">
                                    {leftColkarn.map((item, index) => (
                                        <div
                                            key={index}
                                            className="latest-updates-2__item wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="featured-stories__thumb">
                                                <Link to="/news-details" state={{ news: item }}>
                                                    <img
                                                        src={item.image || 'assets/img/blog/noimage.jpg'} // fallback image
                                                        alt={item.title}
                                                    />
                                                </Link>
                                            </div>
                                            <div className="featured-stories__content">
                                                <h3 className="featured-stories__title">
                                                    <Link to="/news-details" state={{ news: item }}>
                                                        {item.title}
                                                    </Link>
                                                </h3>
                                                <div className="featured-stories__date">
                                                    <span>{new Date(item.pubDate).toLocaleDateString('en-IN')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="trending-posts-4__wrapper mb-24">
                                    {rightColkarn.map((item, index) => (
                                        <div
                                            key={index}
                                            className="latest-updates-2__item wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="featured-stories__thumb">
                                                <Link to="/news-details" state={{ news: item }}>
                                                    <img
                                                        src={item.image || 'assets/img/blog/noimage.jpg'} // fallback image
                                                        alt={item.title}
                                                    />
                                                </Link>
                                            </div>
                                            <div className="featured-stories__content">
                                                <h3 className="featured-stories__title">
                                                    <Link to="/news-details" state={{ news: item }}>
                                                        {item.title}
                                                    </Link>
                                                </h3>
                                                <div className="featured-stories__date">
                                                    <span>{new Date(item.pubDate).toLocaleDateString('en-IN')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/* ---------- NATIONAL NEWS ---------- */}

                <section className="trending-posts-4__area trending-posts-4__space grey-bg section-space-bottom">
                    <div className="container custom-container">
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s">
                                    National News
                                </h3>
                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>
                            <div className="trending-posts-4__btn wow fadeInUp" data-wow-duration="0.7s" data-wow-delay="0.2s">
                                <Link to="/national-allnews-details" className="rr-btn rr-btn-6">
                                    <span className="btn-wrap">
                                        <span className="text-one">View All</span>
                                        <span className="text-two">View All</span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                        <div className="row mb-minus-24">
                            <div className="col-xl-6">
                                <div className="trending-posts-4__wrapper mb-24">
                                    {leftColnat.map((item, index) => (
                                        <div
                                            key={index}
                                            className="latest-updates-2__item wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="featured-stories__thumb">
                                                <Link to="/news-details" state={{ news: item }}>
                                                    <img
                                                        src={item.image || 'assets/img/blog/noimage.jpg'} // fallback image
                                                        alt={item.title}
                                                    />
                                                </Link>
                                            </div>
                                            <div className="featured-stories__content">
                                                <h3 className="featured-stories__title">
                                                    <Link to="/news-details" state={{ news: item }}>
                                                        {item.title}
                                                    </Link>
                                                </h3>
                                                <div className="featured-stories__date">
                                                    <span>{new Date(item.pubDate).toLocaleDateString('en-IN')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="trending-posts-4__wrapper mb-24">
                                    {rightColnat.map((item, index) => (
                                        <div
                                            key={index}
                                            className="latest-updates-2__item wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="featured-stories__thumb">
                                                <Link to="/news-details" state={{ news: item }}>
                                                    <img
                                                        src={item.image || 'assets/img/blog/noimage.jpg'} // fallback image
                                                        alt={item.title}
                                                    />
                                                </Link>
                                            </div>
                                            <div className="featured-stories__content">
                                                <h3 className="featured-stories__title">
                                                    <Link to="/news-details" state={{ news: item }}>
                                                        {item.title}
                                                    </Link>
                                                </h3>
                                                <div className="featured-stories__date">
                                                    <span>{new Date(item.pubDate).toLocaleDateString('en-IN')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/* ---------- ADVERTISEMENT CAROUSEL ---------- */}
                {ads.length > 0 && (
                    <section className="featured-news__area primary_bg4 featured-news__space">
                        <div className="container">
                            <div className="featured-news__top heading-display__wrap">
                                <div className="section-heading__wrap">
                                    <h3 className="section__title wow custom-anim-left text-white">Advertisement</h3>
                                    <div className="section__border" />
                                </div>
                                <div className="featured-news__button">
                                    <div className="featured-news__arrow featured-news__arrow-prev"><i className="fa-solid fa-angle-left" /></div>
                                    <div className="featured-news__arrow featured-news__arrow-next"><i className="fa-solid fa-angle-right" /></div>
                                </div>
                            </div>
                            <Swiper
                                modules={[Navigation]}
                                navigation={{
                                    nextEl: '.featured-news__arrow-next',
                                    prevEl: '.featured-news__arrow-prev',
                                }}
                                slidesPerView={3}
                                spaceBetween={20}
                                breakpoints={{
                                    320: { slidesPerView: 1 },
                                    768: { slidesPerView: 2 },
                                    1024: { slidesPerView: 3 },
                                }}
                                className="featured-news__active"
                            >
                                {ads.map((ad) => (
                                    <SwiperSlide key={ad.id}>
                                        <div className="featured-news__item">
                                            <div className="featured-news__content">
                                                <img src={`${imagaeAPI}/uploads/ads/${ad.ads_photo}`} alt={ad.ads_title} />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </section>
                )}

                {/* ---------- NEWS CATEGORIES (static) ---------- */}


                {/* ---------- INTERVIEWS (Video Grid) ---------- */}


                {/* ---------- KARNATAKA POLICE TV CHANNEL ---------- */}


                {/* ---------- BANGALORE METRO TV CHANNEL ---------- */}
                <section className="featured-news__area featured-news__space" style={{ background: "#842e75" }}>
                    <div className="container">
                        <div className="featured-news__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left text-white">
                                    Bangalore Metro TV Channel
                                </h3>
                                <div className="section__border wow custom-anim-left" />
                            </div>
                            <div className="featured-news__button wow fadeInUp">
                                <div className="featured-news__arrow metro-arrow-prev text-white">
                                    <i className="fa-solid fa-angle-left" />
                                </div>
                                <div className="featured-news__arrow metro-arrow-next text-white">
                                    <i className="fa-solid fa-angle-right" />
                                </div>
                            </div>
                        </div>

                        <Swiper
                            modules={[Navigation]}
                            navigation={{
                                prevEl: '.metro-arrow-prev',
                                nextEl: '.metro-arrow-next',
                            }}
                            spaceBetween={24}
                            slidesPerView={1}
                            breakpoints={{
                                640: { slidesPerView: 2 },
                                1024: { slidesPerView: 3 },
                            }}
                            className="featured-news__active"
                        >
                            {youtubevideosmetro.map((video) => (
                                <SwiperSlide key={video.video_id}>
                                    <div className="featured-news__item">
                                        <div className="featured-news__content">
                                            <iframe
                                                width="100%"
                                                height="100%"
                                                src={`https://www.youtube.com/embed/${video.video_id}`}
                                                title={video.title}
                                                frameBorder="0"
                                                allowFullScreen
                                            />
                                            <p className="text-white-50" style={{ fontSize: '12px' }}>
                                                {new Date(video.published).toLocaleDateString('en-IN', {
                                                    day: 'numeric',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })}
                                            </p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </section>

            </main >

            {/* ===== FOOTER ===== */}

            < Footer />

        </>
    );
};

// ---------- SUBCOMPONENTS ----------



export default Homepage;